import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ReportParameterValues } from '../../report-parameters';
import { ReportDefinition, ReportResponseDto } from '../../reporting.model';
import { ReportKey } from '../report-key.enum';
import { HedgeCoverageDataComponent } from './hedge-coverage-data.component';


export const HedgeCoverageReport: ReportDefinition = {
    reportKey: ReportKey.HedgeCoverage,
    routePath: 'hedge-coverage',
    securityRuleKey: 'beta',
    dataComponent: HedgeCoverageDataComponent,
    reportOptions: {
        showSavedParameters: true,
        showSavedLayouts: false,
        showSavedFilters: false,
        showSavedViews: false,
        showExpandAll: false,
        showCollapseAll: false,
        showAutosizeColumns: false,
        showClearFilters: false,
        showSearch: false,
        exportOptions: []
    },
    parameters: [
        {key: 'productCategoryCostKey', overrides: { required: true }},
        {key: 'divisionHierarchyNodeKeys'},
        {key: 'hedgeReportDateRange'},
        {key: 'customerAverageAnnualDeliveredUnits'},
        {key: 'includeLongCapPremiums' }
    ],
    fetchData: hedgeCoverageFetchData,
    integrationEndpoint: 'v1/reports/hedge-coverage',
    buildIntegrationQueryParams: buildHedgeCoverageReportIntegrationQueryParams
};

export interface HedgeRow {
    monthYear: string;
    month: number;
    year: number;
    deliveryForecastYearMonthKey: number;
    deliveryCurvePercent: number;
    shortCapVolume: number;
    shortFixedVolume: number;
    longCapVolume: number;
    longFixedVolume: number;
    capDifference: number;
    fixedDifference: number;
    shortCapAveragePrice: number;
	shortFixedAveragePrice: number;
	averageCapStrikePrice: number;
	averageFixedStrikePrice: number;
	averageCapUnitCost: number;
    longCapPremium?: number;
    netCapDifference?: number;
    netFixedDifference?: number;
}

function hedgeCoverageFetchData (httpClient: HttpClient, subscriberKey: number | null, params: ReportParameterValues): Observable<any> {
    const body = {
        productCategoryCostKey: params.productCategoryCostKey,
        hierarchyNodeKeys: params.divisionHierarchyNodeKeys,
        deliveryForecastMonths: params.hedgeReportDateRange,
        customerAverageAnnualDeliveredUnits: params.customerAverageAnnualDeliveredUnits
        };

    return httpClient.post<ReportResponseDto<HedgeRow>>(`api/subscriber/${subscriberKey}/hedging/reports/hedge-coverage`, body);
};

function buildHedgeCoverageReportIntegrationQueryParams(params: ReportParameterValues): Record<string, string | string[]> {
    const result: Record<string, string | string[]> = {};

    const divisionHierarchyNodeKeys = params['divisionHierarchyNodeKeys'] as number[] | undefined;
    if (divisionHierarchyNodeKeys?.length) result['divisionHierarchyNodeKeys'] = divisionHierarchyNodeKeys.map(String);

    const productCategoryCostKey = params['productCategoryCostKey'] as number | undefined;
    result['productCategoryCostKey'] = productCategoryCostKey?.toString() ?? '';

    const deliveryForecastMonths = params['hedgeReportDateRange'] as number | undefined;
    result['deliveryForecastMonths'] = deliveryForecastMonths?.toString() ?? '';

    const customerAverageAnnualDeliveredUnits = params['customerAverageAnnualDeliveredUnits'] as number | undefined;
    result['customerAverageAnnualDeliveredUnits'] = customerAverageAnnualDeliveredUnits?.toString() ?? '';

    return result;
}

